import {useNavigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from '../../shared/store/useBookingStore';
import {useLayoutEffect} from 'react';

const useFavoriteDoctorsNavigation = () => {
	const navigate = useNavigate();
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const resetBookingData = useBookingStore(state => state.resetBookingData);

	const handleGoToHome = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	useLayoutEffect(() => {
		resetBookingData({isFavoriteDoctorsFlow: true});
	}, [resetBookingData]);

	return {handleGoToHome, setActiveBookingFlowStep};
};

export {useFavoriteDoctorsNavigation};
